import { create } from "zustand";

interface DialogStore {
  createDialog: boolean;
  updateDialog: boolean;
  deleteDialog: boolean;
  openCreateDialog: () => void;
  closeCreateDialog: () => void;
  openUpdateDialog: () => void;
  closeUpdateDialog: () => void;
  openDeleteDialog: () => void;
  closeDeleteDialog: () => void;
}

export const useDialogStore = create<DialogStore>((set) => ({
  createDialog: false,
  updateDialog: false,
  deleteDialog: false,
  openCreateDialog: () => set({ createDialog: true }),
  closeCreateDialog: () => set({ createDialog: false }),
  openUpdateDialog: () => set({ updateDialog: true }),
  closeUpdateDialog: () => set({ updateDialog: false }),
  openDeleteDialog: () => set({ deleteDialog: true }),
  closeDeleteDialog: () => set({ deleteDialog: false }),
}));